import React from "react";
import { Box, useTheme } from "@mui/material";

interface BackgroundWrapperProps {
  children: React.ReactNode;
}

const BackgroundWrapper: React.FC<BackgroundWrapperProps> = ({ children }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        position: "relative",
        backgroundColor: theme.palette.background.default,
      }}
    >
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          width: "100%",
          flexGrow: 1,
          px: 2,
          py: { xs: 2, md: 3 },
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default BackgroundWrapper;
